<template>
  <v-container fluid  grid-list-md class="pa-0">
    <v-layout>
      <v-flex xs12 class="mx-auto">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="pa-2 grey lighten-4">
            <div class="title grey--text">
              Recent Incidents
            </div>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="incidentHeader"
            :items="incidentList"
            class="elevation-1"
            hide-actions
            >
            <template slot="items" slot-scope="props">
              <tr @click="editIncident(props.item)">
                <td>{{ handy.formatDate(props.item.incident_on) }}</td>
                <td>{{ props.item.severity }}</td>
                <td>{{ props.item.incident_desc }}</td>
                <td>{{ props.item.rca }}</td>
                <td>{{ props.item.created_by_name }}</td>
                <td>{{ handy.formatDate(props.item.created_on) }}</td>
                <td>{{ props.item.updated_by_name }}</td>
                <td>{{ props.item.updated_on ? handy.formatDate(props.item.updated_on) : null }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-1" grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm6 class="mx-auto">
            <v-form ref="lForm" id="form" @submit.prevent="saveChanges(lAction)">
              <v-card flat>
                <v-card-title class="title pa-2">
                  {{ handy.startWithUpper(lAction) + ' Incident' }}
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-dialog ref="incidentOnDate"
                      persistent v-model="incidentOnDate"
                      max-width="290px"
                      :return-value.sync="lIncident.incident_on_date"
                      >
                      <v-text-field
                      slot="activator" label="Incident date"
                      v-model="lIncident.incident_on_date"
                      append-icon="event"
                      readonly clearable
                      hide-details
                      :rules="[rules.required]"
                      ></v-text-field>
                      <v-date-picker v-model="lIncident.incident_on_date" scrollable
                      first-day-of-week="1" :max="today"
                      >
                      <v-spacer></v-spacer>
                      <v-btn flat @click="incidentOnDate = false">Cancel</v-btn>
                      <v-btn flat color="accent" @click="$refs.incidentOnDate.save(lIncident.incident_on_date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6>
                  <v-dialog
                  ref="incidentTime"
                  persistent
                  v-model="incidentTime"
                  max-width="290px"
                  lazy
                  :return-value.sync="lIncident.startTime"
                  >
                  <v-text-field
                  slot="activator"
                  label="Incident time"
                  v-model="lIncident.startTime"
                  append-icon="access_time"
                  clearable
                  hide-details
                  readonly
                  :rules="[rules.required]"
                  ></v-text-field>
                  <v-time-picker v-model="lIncident.startTime">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="incidentTime = false">Cancel</v-btn>
                    <v-btn flat color="accent" @click="$refs.incidentTime.save(lIncident.startTime)">OK</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6>
                <v-select
                v-model="lIncident.severity"
                label="Priority"
                :items="['Normal', 'Low', 'High']"
                hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                class="mt-2"
                v-model="lIncident.incident_desc"
                label="Incident description"
                :rules="[rules.required]"
                hide-details
                rows="4"
                maxlength="1000"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 v-if="lAction === 'update'">
                <v-textarea
                class="mt-2"
                v-model="lIncident.rca"
                label="RCA"
                :rules="[rules.required]"
                hide-details
                rows="4"
                maxlength="1000"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <input style="display:none" type="file" ref="fileInput"
                accept=".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser()"/>
                <v-btn icon @click="pickFile"><v-icon>attach_file</v-icon></v-btn>
                <span v-if="lIncident.files.filter(rec => rec.is_selected).length > 0">
                  <span v-for="(file, index) in lIncident.files" :key="index">
                    <v-chip v-model="file.is_selected" close @input="$forceUpdate()">
                      {{ file.file_name }}
                      <span v-if="!file.is_changed">
                        <a :href="config.FILE_URL(file.file_url)" download style="text-decoration: none;">
                          <v-btn small icon class="mr-0 grey lighten-1 grey--text text--lighten-4">
                            <v-icon small>file_download</v-icon>
                          </v-btn>
                        </a>
                      </span>
                    </v-chip>
                  </span>
                </span>
                <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.stop="lAction = 'view'">cancel</v-btn>
            <v-btn v-if="lAction === 'update'" flat @click.stop="deleteIncident">Delete</v-btn>
            <v-btn flat type="submit" color="accent" :disabled="beingSaved">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>


<v-btn
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed color="accent" v-if="lAction === 'view'"
@click.native="prepareCreate">
<v-icon>add</v-icon>
</v-btn>
</v-flex>
</v-layout>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      lAction: 'view',
      lIncident: {},
      incidentList: [],
      incidentTime: false,
      incidentOnDate: false,
      beingSaved: false,
      incidentHeader: [
        { text: 'Incident-On', value: 'incident_on' },
        { text: 'Severity', value: 'severity' },
        { text: 'Incident Discription', value: 'incident_desc' },
        { text: 'RCA', value: 'rca' },
        { text: 'Created By', value: 'created_by' },
        { text: 'Created On', value: 'created_on' },
        { text: 'Last Updated By', value: 'updated_by' },
        { text: 'Last Updated On', value: 'updated_on' }
      ]
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  mounted () {
    this.loadIncidents()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadIncidents () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getIncidents/', qry)
      .then(response => {
        this.incidentList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.incidentList = []
      })
    },
    loadIncidentAttachment (curIncident) {
      var path = require('path')
      var qry = {
        params: {
          incident_id: curIncident.incident_id
        }
      }
      curIncident.files = []
      this.axios.get(config.API_URL + '/getAttachmentByIncidentId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          curIncident.files.push({
            file_url: rec.file_url,
            file_name: path.basename(rec.file_url),
            is_selected: true,
            is_changed: false
          })
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreate () {
      this.lIncident = {
        incident_on: null,
        comm_id: config.COMM_ID,
        severity: 'Normal',
        incident_desc: '',
        rca: '',
        created_by: config.USER_ID,
        files: []
      }
      this.lAction = 'create'
    },
    saveChanges (action) {
      // validate and save Changes
      if (action === 'create' || action === 'update') {
        if (!this.lIncident.incident_on_date) {
          this.msg('Please enter date & time', 0)
        }
        if (!this.$refs.lForm.validate()) {
          return
        }
        this.beingSaved = true
        this.lIncident.created_by = config.USER_ID
        this.lIncident.comm_id = config.COMM_ID
        this.lIncident.incident_on = this.lIncident.incident_on_date + ' ' + this.lIncident.startTime
        this.axios.post(config.API_URL + '/incidents/' + action, this.lIncident)
        .then(response => {
          this.lIncident.incident_id = response.data
          this.loadIncidents()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    deleteIncident (curIncident) {
      if (!confirm('Sure, you want to delete the incident')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/incidents/delete', this.lIncident)
      .then(response => {
        this.idx = this.incidentList.findIndex(rec => rec.incident_id === this.lIncident.incident_id)
        this.incidentList.splice(this.idx, 1)
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    editIncident (curIncident) {
      this.loadIncidentAttachment(curIncident)
      this.lIncident = Object.assign({}, curIncident)
      this.lIncident.updated_by = config.USER_ID
      this.lIncident.incident_on_date = handy.formatDBDate(this.lIncident.incident_on)
      this.lIncident.startTime = handy.getLongTime(this.lIncident.incident_on_date)
      this.lAction = 'update'
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser () {
      const files = event.target.files
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            this.lIncident.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
          console.log(this.lIncident.files)
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// IncidentReports.vue?4ae1a64a